import { SVGProps } from 'react';
import SVGLogo from './SVGLogo';
import SVGIcon from './SVGIcon';

export default Object.assign(
  ({ children, ...rest }: SVGProps<any>) => {
    return (
      <svg
        className={`svg`}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...rest}
      >
        {children}
      </svg>
    );
  },
  {
    Icon: SVGIcon,
    Logo: SVGLogo,
  },
);
